module.exports = __webpack_public_path__ + "1f4f6cc4bb481b0f97d57d428e296576.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/icons/bouteille-more.svg
// module id = 734
// module chunks = 0